import {
  ASSESSMENT_PAGE_BOOLEAN_FIELD_NAMES,
  ASSESSMENT_PAGE_STRING_ARRAY_FIELD_NAMES,
  ASSESSMENT_PAGE_STRING_FIELD_NAMES,
} from './constants';

import type {
  AssessmentPageFieldName,
  ITreatmentPlanV3AssessmentMethodVisual,
  ITreatmentPlanV3AssessmentPage,
  TreatmentPlanV3AssessmentPagePayload,
} from './types';

export function applyTreatmentPlanV3AssessmentPageFields(
  page: ITreatmentPlanV3AssessmentPage,
  payload: ITreatmentPlanV3AssessmentPage,
  data: TreatmentPlanV3AssessmentPagePayload,
) {
  applyHomogeneousAssessmentPageFields(page, payload, data, ASSESSMENT_PAGE_STRING_FIELD_NAMES);
  applyHomogeneousAssessmentPageFields(page, payload, data, ASSESSMENT_PAGE_BOOLEAN_FIELD_NAMES);
  applyHomogeneousAssessmentPageFields(
    page,
    payload,
    data,
    ASSESSMENT_PAGE_STRING_ARRAY_FIELD_NAMES,
  );
}

function applyHomogeneousAssessmentPageFields<K extends AssessmentPageFieldName>(
  page: ITreatmentPlanV3AssessmentPage,
  payload: ITreatmentPlanV3AssessmentPage,
  data: TreatmentPlanV3AssessmentPagePayload,
  names: readonly K[],
) {
  for (const name of names) {
    if (name in data) {
      page[name] = payload[name];
    }
  }
}

export function applyAssessmentMethodVisualMetadata(
  visuals: ITreatmentPlanV3AssessmentMethodVisual[],
  visual: ITreatmentPlanV3AssessmentMethodVisual,
) {
  const index = visuals.findIndex((row) => row.id === visual.id);
  if (index === -1) {
    visuals.push(visual);
    return;
  }
  const current = visuals[index];
  if (!current) return;
  visuals[index] = {
    ...current,
    title: visual.title,
    analysis: visual.analysis,
  };
}

export function applyAssessmentMethodVisualFile(
  visuals: ITreatmentPlanV3AssessmentMethodVisual[],
  visual: ITreatmentPlanV3AssessmentMethodVisual,
) {
  const index = visuals.findIndex((row) => row.id === visual.id);
  const current = index === -1 ? undefined : visuals[index];
  if (!current) return;
  visuals[index] = {
    ...current,
    url: visual.url,
  };
}

export function buildTreatmentPlanV3AssessmentMethodVisualsFormData(files: File[]): FormData {
  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file);
  }
  return formData;
}

export function buildTreatmentPlanV3AssessmentMethodVisualFileFormData(file: File): FormData {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
}
